'use client';
import { GoArrowLeft } from 'react-icons/go';
import { showCustomAlert } from './utils';

export default function RegisteredAgentStep({ formik, onBack, onNext }) {
  return (
    <>
      <button
        type="button"
        onClick={onBack}
        className="mb-[0.5rem] flex cursor-pointer items-center gap-[0.5rem] text-[1rem] font-bold text-dark transition-colors hover:text-blue-600 focus:outline-none"
      >
        <GoArrowLeft size={18} />
        <span className="text-base font-semibold">Back</span>
      </button>
      <h2 className="mb-[1rem] text-[1.15rem] font-bold leading-tight text-[#191919]">
        Are you sure you can meet this state requirement?
      </h2>
      <p className="mb-[1.25rem] text-[0.9rem] text-light-gray">
        Most people choose Thera to be their Registered Agent because the requirements can be hard to meet on your own.
      </p>
      <div className="mb-[1.5rem] space-y-[0.5rem] rounded-lg border-l-4 border-l-therablue bg-bg-gray p-5 text-[1rem] text-dark-gray">
        <div className="mb-[1rem] flex flex-col items-start gap-[0.5rem] lg:flex-row lg:items-center">
          <span className="bg-primary rounded-full bg-therablue px-[0.5rem] py-[0.25rem] text-[1rem] font-medium text-white">
            State requirement
          </span>
        </div>
        <p className="!mb-5">
          You need to provide a physical address for your Registered Agent in the state you're doing business. It can't
          be a PO Box.
        </p>
        <p>
          Depending on your state, that address may show up on public records with your name, phone number, and email
          address.
        </p>
      </div>
      <div className="mb-[0.5rem] flex gap-[1rem]">
        <button
          type="button"
          className={`w-full rounded-md border border-light-gray bg-white py-[0.7rem] text-[1rem] font-[600] text-black transition-all`}
          onClick={() => {
            showCustomAlert('Are you sure you want to appoint your own Registered Agent?').then((result) => {
              if (result.isConfirmed) {
                formik.setFieldValue('agent', 'own');
                onNext?.();
              }
            });
          }}
        >
          Appoint your own
        </button>
        <button
          type="button"
          className={`w-full rounded-md border py-[0.7rem] text-[1rem] font-[600] text-light-gray transition-all ${true ? 'border-[#181818] bg-black text-white' : 'border-[#E5E7EB] bg-white text-black'} `}
          onClick={() => {
            formik.setFieldValue('agent', 'thera');
            onNext?.();
          }}
        >
          Appoint Thera
        </button>

        {formik.touched.agent && formik.errors.agent && (
          <div className="mt-[0.25rem] text-[0.875rem] text-red-500">{formik.errors.agent}</div>
        )}
      </div>
    </>
  );
}
